import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Checkbox from '../../Checkbox';
import './LocationCheckbox.scss';

const LocationCheckbox = ({
  code,
  name,
  primary,
  checked,
  onChange,
  disabled,
}) => {
  const elementName = `LocationCheckbox__${code}`;
  const disabledOrPrimary = disabled || code === primary;
  return (
    <div className={cx('LocationCheckbox', {
      'LocationCheckbox--disabled': disabledOrPrimary,
    })}
    >
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <label htmlFor={elementName}>
        <Checkbox
          key={code}
          name={elementName}
          checked={checked}
          onChange={(obj) => {
            onChange(obj[elementName], code);
          }}
          disabled={disabledOrPrimary}
        />
        <div className="LocationCheckbox__label">{name}</div>
      </label>
    </div>
  );
};

LocationCheckbox.propTypes = {
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  primary: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

LocationCheckbox.defaultProps = {
  onChange: () => {},
  primary: null,
  disabled: false,
};

export default LocationCheckbox;
